
export const redirectUrlList = [
    {
        value:'',
        label:'直接领取',
        isNeedparameter:false
    },
    {
        value:'/##ggzs/',
        label:'公告展示',
        isNeedparameter:false
    },
    {
        value:'../../p_my/top_up/top_up',
        label:'充值页面',
        isNeedparameter:false
    },
    {
        value:'../../p_my/top_up/top_up?',
        label:'专属地区充值页面',
        isNeedparameter:true,
        parameterDesc:'请输入门店id，格式为store_id=1'
    },
    {
        value:'../../p_my/league/league',
        label:'加盟页面',
        isNeedparameter:false
    },
    {
        value:'../../p_store/store_detail/store_detail?',
        label:'商品详情页',
        isNeedparameter:true,
        parameterDesc:'请输入商品id，格式为id=1'
    }
]